import { CategoryRecord } from '../types/inventoryItem';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const categoryDetailQueryAtom = createQueryAtomFactory(
  'settings.categoryDetail',
  (params: { ids: string[] }) => ({
    categories: {
      __args: {
        filter: {
          ids: params.ids,
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        description: true,
        attributes: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data): CategoryRecord | null => {
      const category = data?.categories?.entries?.[0];
      if (!category) {
        return null;
      }

      const rawAttributes = category.attributes as
        | Record<string, unknown>
        | undefined;
      const attributes = rawAttributes
        ? Object.entries(rawAttributes).map(([name, value]) => {
            const attrValue = value as Record<string, unknown>;
            return {
              name,
              description: (attrValue?.description as string) ?? '',
              dataType: (attrValue?.dataType as string) ?? 'STRING',
              required: (attrValue?.required as boolean) ?? false,
              validationExpr: (attrValue?.validationExpr as string) ?? null,
              options: (attrValue?.options as string[]) ?? null,
            };
          })
        : [];

      return {
        id: category.id,
        name: category.name,
        description: category.description,
        attributes,
        timestamps: {
          createdAt: parseZonedDateTime(category.timestamps.createdAt),
          updatedAt: parseZonedDateTime(category.timestamps.updatedAt),
        },
      };
    },
  },
);
